export default function RegisterPage() {
	return (
		<div>
			<h1>Register Page</h1>
			<p>This is the registration page for new users.</p>
		</div>
	);
}
